import React, { Component } from 'react';
import WhitePilotlyLogo from '../../assets/landing/WhitePilotlyLogo';


class TechCheckHeader extends Component {
	render() {
		return (
			<header
				style={{ ...this.props.styles }}
				className="landing-header sticky-landing-header z-depth-1 blue-bg z-depth-0"
			>
				<nav className="landing-header-container-web z-depth-0">
					<div className="landing-header-btn-container logo-container">
						<img
							className="landing-header-logo noselect sticky-landing-header-logo"
							src={WhitePilotlyLogo}
							alt="Pilotly"
						/>
					</div>
				</nav>
			</header>
		);
	}
}

export default TechCheckHeader;



// WEBPACK FOOTER //
// ./src/components/tech-check/TechCheckHeader.js